import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import { HeaderComponent } from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import PromotionMarkup from "../PromotionMarkup";

const defaultCollapseKey = "configPromotionMarkupSection";

function ConfigPromotionMarkupSection(props) {
  const {
    campaign,
    validation,
    channels,
    onChangeCampaignMarkup,
    getMarkupPromotionConfig,
    getMarkupPromotionFly,
    getMarkupBundleMinValue,
    campaignState,
  } = props;

  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();

  const onToggleCollapse = () => {
    if (collapseKey) {
      setCollapseKey();
    } else {
      setCollapseKey(defaultCollapseKey);
    }
  };

  useEffect(() => {
    const hasError = validation && validation.promotionMarkup
    if (hasError && !collapseKey) {
      setCollapseKey(defaultCollapseKey);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validation])

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.titleConfigPromotionMarkup")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          {!!validation.promotionMarkup && (
            <Wrapper className="text-red">
              * {validation.promotionMarkup || ""}
            </Wrapper>
          )}
          <div
            className={classNames(`col-md-12`, {
              "border-red": !!validation.promotionMarkup
            })}
          >
            <PromotionMarkup
              t={t}
              getMarkupPromotionConfig={getMarkupPromotionConfig}
              getMarkupPromotionFly={getMarkupPromotionFly}
              getMarkupBundleMinValue={getMarkupBundleMinValue}
              campaignState={campaignState}
              campaign={campaign}
              channels={channels}
              onChangeCampaignMarkup={onChangeCampaignMarkup}
            />
          </div>
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

ConfigPromotionMarkupSection.propTypes = {
  campaign: PropTypes.object,
  validation: PropTypes.object,
  channels: PropTypes.object,
  promotionMarkupProps: PropTypes.object,
  onChangeCampaignMarkup: PropTypes.func
};

ConfigPromotionMarkupSection.defaultProps = {
  campaign: {},
  validation: {},
  channels: {},
  promotionMarkupProps: {},
  onChangeCampaignMarkup: () => {}
};

export default ConfigPromotionMarkupSection;
